import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import * as systemDataActions from '../Redux/SystemData/systemDataActions';

const useLanguageParam = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    // Debug Log 1: Verify hook initializes
    console.log("DEBUG: useLanguageParam hook is active."); 
    console.log("DEBUG: Current URL Search Params:", searchParams.toString());

    useEffect(() => {
        const lan = searchParams.get('lan');
        const language = searchParams.get('language');
        console.log(`DEBUG: lan=${lan}, language=${language}`);
        if (lan === 'en' || language === 'en') {
            dispatch(systemDataActions.updateSystemData({ language: 'en', dir: 'ltr' }));
        }
    }, [searchParams, dispatch]);
};

export default useLanguageParam;